import { useEffect, useState, useMemo, useContext, useCallback } from "react";
import { getTokens } from "./Utilities/tokenUtility";
import { FrontendDataContext } from "./Utilities/FrontendDataContext";
import { useNavigate } from "react-router-dom";
import { handleAuthenticate, handleRevokeToken } from "./SettingsPopup"; // Assuming this is the function to handle OAuth
import { AuthContext } from "./Utilities/AuthContext";
import { revokeSession } from "./App";
// import { BackendDataContext } from "./Utilities/BackendDataContext";
import { HiXMark } from "react-icons/hi2";
import { AiFillEdit } from "react-icons/ai";
import { IoIosCheckmark } from "react-icons/io";
import { updatePhoneSetting } from "./Utilities/settingsUtility";
import { saveDotloopSettings } from "./Utilities/dotloopSettingsHandler";

// const gmail = "/assets/gmail.png";
// const googleDrive = "/assets/driveLogo.svg";
// const googleCalendar = "/assets/google-calendar-icon.png";

const availableTokens = [
    { name: "DealCompass CRM", provider: "DealCompass", srcImage: "/assets/DealCompass_Initials_BlueLetters_TransparentBg_clipped_rev_1.png" },
    { name: "Google", provider: "google", srcImage: "/assets/google-calendar-icon.png" },
    { name: "Microsoft", provider: "graph", srcImage: "/assets/outlook_calendar.png" },
    { name: "Dotloop", provider: "dotloop", srcImage: "/assets/dotloopFullLogo.png" },
    { name: "Trello", provider: "trello", srcImage: "/assets/trello.svg" },
]



const Profile = () => {
  const [profileFound, setProfileFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profileName, setProfileName] = useState("Loading…");
  const [usersTokens, setUsersTokens] = useState([]);
  const [stripeData, setStripeData] = useState({});
  const [userSeats, setUserSeats] = useState(1);
  const [statusMsg, setStatusMsg] = useState(null);
  const [phoneChatSettings, setPhoneChatSettings] = useState("");
  const [dotloopStaticMapping, setDotloopStaticMapping] = useState([]);
  const [dotloopColumnMapping, setDotloopColumnMapping] = useState([]);
  const [dealHeaderColumns, setDealHeaderColumns] = useState([]);
  const [contactHeaderColumns, setContactHeaderColumns] = useState([]);

  const navigate = useNavigate();
  

  const { triggerLoadAlert, triggerSuccessAlert, triggerFailAlert } = useContext(FrontendDataContext)

  const [tempNewReminderTime, setTempNewReminderTime] = useState("");
  
  useEffect(()=>{
    setTempNewReminderTime("")
  }, [phoneChatSettings])


  const [isEditingPhoneNumber, setIsEditingPhoneNumber] = useState(false)



  const getProfileData = useCallback(async () => {
    triggerLoadAlert('Refreshing your profile'); // --- IGNORE ---
    getTokens().then(res=>{
        setUsersTokens(res.tokens || []);
        setStripeData(res.session?.StripeData || {});
        if (res.session?.StripeData?.quantity) {
          setUserSeats(res.session.StripeData.quantity);
        }
        setPhoneChatSettings(res.session?.PhoneChatSettings || {});
        setStatusMsg("");
        setDotloopColumnMapping(res.session?.DotloopColumnMapping || []);
        setDotloopStaticMapping(res.session?.DotloopStaticMapping || []);
        setDealHeaderColumns(res.session?.DealHeaderColumns || []);
        setContactHeaderColumns(res.session?.ContactHeaderColumns || []);
        triggerSuccessAlert('Plan refreshed'); // --- IGNORE ---
    }).catch(e=>{
        console.error("Error fetching tokens:", e);
        setStatusMsg("Error refreshing data.");
        triggerFailAlert('Error refreshing data'); // --- IGNORE ---
    });
}, [triggerFailAlert, triggerSuccessAlert, triggerLoadAlert])

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await getTokens();
        if (!mounted) return;

        // if (!res.session?.ClientName) {
        //     alert('No profile found, redirecting to home page');
        //     localStorage.removeItem('UserSessionID');
        //     navigate("/");
        //     return;
        // }
        setProfileName(res.session?.ClientName || "No profile found");
        setUsersTokens(res.tokens || []);
        setStripeData(res.session?.StripeData || {});
        setPhoneChatSettings(res.session?.PhoneChatSettings || {});
        setProfileFound(Boolean(res.session?.ClientName));
        setDotloopColumnMapping(res.session?.DotloopColumnMapping || []);
        setDotloopStaticMapping(res.session?.DotloopStaticMapping || []);
        setDealHeaderColumns(res.session?.DealHeaderColumns || []);
        setContactHeaderColumns(res.session?.ContactHeaderColumns || []);
        if (res.session?.StripeData?.quantity) {
          setUserSeats(res.session.StripeData.quantity);
        }
      } catch (err) {
        console.error("Error fetching tokens:", err);
        setProfileName("Error loading profile");
        setProfileFound(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [navigate]);



  const fmtMoney = (cents, plan) => {

    if (typeof cents !== "number") return "Free"

    const dollarsPerPayment = (cents / 100).toFixed(2)
    const paymentsPerYear = plan.interval === "year" ? 1 : (plan.interval === "month" ? (12 / plan.interval_count) : 1)

    const res = `$${dollarsPerPayment * paymentsPerYear / 12}` 

    return res
  }



  const nextPayment = useMemo(() => {
    if (!stripeData?.nextPayment) return "N/A";
    try { return new Date(stripeData.nextPayment).toLocaleString() !== "Invalid Date" ? new Date(stripeData.nextPayment).toLocaleString() : "N/A"; }
    catch { return stripeData.nextPayment; }
  }, [stripeData]);

  // ---- Styles (inline, no deps) ----
  const styles = {
    page: {
      minHeight: "100dvh",
      minWidth: "100dvw",
      background: "linear-gradient(180deg,#f8fafc 0%, #ffffff 100%)",
      fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif",
      color: "#0f172a",
      overflow: "scroll"
    },
    container: {
      maxWidth: 1280,
      margin: "0 auto",
      padding: "32px 20px 56px",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 24,
      width: "100%",
      flexWrap: "wrap",
      // border: "1px solid red",
      gap: "15px"
    },
    title: { fontSize: 24, fontWeight: 700, letterSpacing: 0.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    subtitle: { color: "#64748b", marginTop: 4 },
    grid: {
    //   display: "grid",
    //   gridTemplateColumns: "1fr",
    //   gap: 20,
    display: "flex", flexWrap: "wrap", gap: 40,
    marginTop: 50
    },
    card: {
      background: "#fff",
      borderRadius: 16,
      border: "1px solid #e2e8f0",
      boxShadow: "0 1px 2px rgba(0,0,0,0.04), 0 12px 24px rgba(2,6,23,0.06)",
      overflow: "hidden",
      flex: 1,
      minWidth: "300px",
      display: "flex", flexDirection: "column",
    },
    cardHeader: {
      padding: "16px 18px",
      borderBottom: "1px solid #e2e8f0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "#f8fafc",
    },
    cardTitle: { fontWeight: 700 },
    cardBody: { padding: 18 },
    badgeRow: { display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "flex-start", alignItems: "flex-start" },
    badge: {
      fontSize: 12,
      padding: "6px 10px",
      borderRadius: 999,
      background: "#eef2ff",
      color: "#3730a3",
      border: "1px solid #e0e7ff",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        height: "fit-content"
    },
    badgeInactive: {
        fontSize: 12,
        padding: "6px 10px",
        borderRadius: 999,
        background: "white",
        color: "#6b7280",
        border: "1px solid #d1d5db",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        height: "fit-content",
    },
    emptyText: { color: "#64748b", fontStyle: "italic" },
    row: { display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10 },
    label: { color: "#475569" },
    value: { fontWeight: 600, color: "rgb(89,89,89)" },
    seatsWrap: { display: "flex", alignItems: "center", gap: 8, marginTop: 10 },
    stepperBtn: {
      width: 36,
      height: 36,
      borderRadius: 10,
      background: "#f1f5f9",
      border: "1px solid #e2e8f0",
      fontWeight: 700,
      cursor: "pointer",
      transition: "all .15s ease",
    },
    seatsInput: {
      width: 72,
      height: 36,
      borderRadius: 10,
      border: "1px solid #e2e8f0",
      background: "#fff",
      textAlign: "center",
      fontWeight: 600,
      outline: "none",
    },
    actions: { display: "flex", flexWrap: "wrap", gap: 10, marginTop: 16 },
    btn: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px 16px",
      borderRadius: 6,
      border: "1px solid transparent",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
      transition: "transform .12s ease, box-shadow .12s ease, background .12s ease",
      fontSize: 14
    },
    btnPrimary: { background: "rgb(30, 161, 56)", color: "#fff", borderRadius: 6 },
    btnNeutral: { background: "#f1f5f9", color: "#0f172a", border: "1px solid #e2e8f0" },
    btnDanger: { background: "#dc2626", color: "#fff" },
    status: {
      marginTop: 12,
      fontSize: 13,
      color: "#475569",
      display: "flex", alignItems: "center",
      justifyContent: "flex-end",
      gap: "5px"
    },
    loader: {
      // marginTop: 24,
      width: 24,
      height: 24,
      borderRadius: "50%",
      border: "3px solid #e2e8f0",
      borderTopColor: "#0ea5e9",
      animation: "spin 1s linear infinite",
    },
    // simple keyframes polyfill (inject once)
  };

  // inject minimal @keyframes for the spinner
  useEffect(() => {
    const id = "profile-spin-kf";
    if (!document.getElementById(id)) {
      const style = document.createElement("style");
      style.id = id;
      style.innerHTML = `@keyframes spin{to{transform:rotate(360deg)}}`;
      document.head.appendChild(style);
    }
  }, []);

  const clampSeats = (n) => Math.max(1, Math.min(10, n || 1));
  const setSeatsSafe = (n) => setUserSeats(clampSeats(n));

  const createCheckout = async () => {
    setStatusMsg(null);
    try {
      const res = await fetch("https://functionappfordev.azurewebsites.net/api/stripeHandler?action=CREATE_CHECKOUT_SESSION", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-UserSessionID": localStorage.getItem("UserSessionID") || "",
        },
        body: JSON.stringify({ quantity: userSeats }),
      });
      const data = await res.json();
      if (data.url) {
        // window.open(data.url, "_blank");
        window.location.href = data.url
      } else {
        setStatusMsg("Could not start checkout. Please try again.");
        console.error("No URL returned from Stripe:", data);
      }
    } catch (e) {
      setStatusMsg("Network error creating checkout.");
      console.error(e);
    }
  };

  const updateSubscription = async () => {
    setStatusMsg(null);
    try {
        triggerLoadAlert('Updating your plan'); // --- IGNORE ---
      const res = await fetch("https://functionappfordev.azurewebsites.net/api/stripeHandler?action=UPDATE_SUBSCRIPTION", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-UserSessionID": localStorage.getItem("UserSessionID") || "",
        },
        body: JSON.stringify({ newQuantity: userSeats }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatusMsg("Subscription updated successfully.");
        triggerSuccessAlert('Plan updated'); // --- IGNORE ---
      } else {
        triggerFailAlert('Error updating plan'); // --- IGNORE ---
        setStatusMsg(data?.message || "Error updating subscription.");
      }
    } catch (e) {
        triggerFailAlert('Network error updating plan'); // --- IGNORE ---
      setStatusMsg("Network error updating subscription.");
      console.error(e);
    }
  };

  const unsubscribe = async () => {
    setStatusMsg(null);
    try {
      const res = await fetch("https://functionappfordev.azurewebsites.net/api/stripeHandler?action=UNSUBSCRIBE", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-UserSessionID": localStorage.getItem("UserSessionID") || "",
        },
      });
      const data = await res.json();
      if (res.ok) {
        setStatusMsg("Unsubscribed successfully.");
      } else {
        setStatusMsg(data?.message || "Error unsubscribing.");
      }
    } catch (e) {
      setStatusMsg("Network error unsubscribing.");
      console.error(e);
    }
  };

const { setIsLoggedIn } = useContext(AuthContext);
  


  return (
    <div style={{...styles.page, paddingBottom: "100px"}}>
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={{overflow: "hidden", flex: "1.5", minWidth: "50%"}}>
            <div style={styles.title}>{profileName}</div>
            <div style={styles.subtitle}>
              {profileFound ? "Account settings & billing" : "Sign in to manage your account"}
            </div>
          </div>



        <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px", flexWrap: "wrap", flex: "1", minWidth: "fit-content", overflow: "hidden"}}>
          <button 
           style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            padding: "10px 16px",
            borderRadius: "5px",
            border: "1px solid #e2e8f0",
            background: "#ffffff",
            color: "#0f172a",
            fontWeight: 600,
            fontSize: 14,
            minWidth: "120px",
            cursor: "pointer",
            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
            transition:
              "transform 120ms ease, box-shadow 120ms ease, background 120ms ease, border-color 120ms ease",
              textAlign: "center"
          }}
            onClick={()=>{
            navigate("/")
          }}>Back to chat</button>


          <button style={{            
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    padding: "10px 16px",
                                    borderRadius: "5px",
                                    border: "1px solid #e2e8f0",
                                    background: "#ffffff",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    minWidth: "120px",
                                    cursor: "pointer",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                                    transition:
                                    "transform 120ms ease, box-shadow 120ms ease, background 120ms ease, border-color 120ms ease",
                                    textAlign: "center",
                                    color: "red"
                                    
                        }}
                        onClick={()=>{
                            revokeSession(setIsLoggedIn);
                            navigate("/")
                        }}>Log out
          </button>

          </div>
        </div>

        {/* Layout: Billing (left) + Tokens (right) on wide screens */}
        <div style={styles.grid}>

        {false && <div style={styles.card}>
            <div style={styles.cardHeader}>
                <div style={styles.cardTitle}>Billing</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                    Manage your subscription & seats
                </div>
            </div>
            <div style={styles.cardBody}>
                {loading ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={styles.loader} />
                        <div style={{ color: "#64748b" }}>Loading billing data…</div>
                    </div>
                ) : (
                    <>
                        <div style={styles.row}>
                            <div style={styles.label}>Price / seat</div>
                            <div style={styles.value}>
                                {fmtMoney(stripeData.amount, stripeData.plan)} {stripeData.currency ? stripeData.currency.toUpperCase() : ""} / mo
                            </div>
                        </div>
                        <div style={styles.row}>
                            <div style={styles.label}>Current seats</div>
                            <div style={styles.value}>{stripeData.quantity ?? "-"}</div>
                        </div>
                        <div style={styles.row}>
                            <div style={styles.label}>Next payment</div>
                            <div style={styles.value}>
                                {nextPayment && new Date(nextPayment).toLocaleString() !== "Invalid Date"
                                    ? new Date(nextPayment).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
                                    : "-"}
                            </div>
                        </div>

                        <div style={{width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "flex-end"}}>
                        <div >
                        <div style={{ marginTop: 18, color: "rgb(109,109,109)", fontWeight: 400, textAlign: "right", fontSize: "14px" }}>{Object.keys(stripeData)?.length === 0 ? "Add seats" : "Adjust seats"}</div>
                        <div style={styles.seatsWrap}>
                            <button
                                type="button"
                                style={styles.stepperBtn}
                                onClick={() => setSeatsSafe(userSeats - 1)}
                                aria-label="Decrease seats"
                            >
                                –
                            </button>
                            <input
                                type="number"
                                min={1}
                                max={10}
                                value={userSeats}
                                onChange={(e) => setSeatsSafe(parseInt(e.target.value, 10))}
                                style={styles.seatsInput}
                            />
                            <button
                                type="button"
                                style={styles.stepperBtn}
                                onClick={() => setSeatsSafe(userSeats + 1)}
                                aria-label="Increase seats"
                            >
                                +
                            </button>
                        </div>
                        </div>
                        </div>

                        <div style={styles.actions}>
                            { Object.keys(stripeData).length === 0 ? (
                                <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 10}}>
                                <button style={{ ...styles.btn, ...styles.btnPrimary }} onClick={createCheckout}>
                                    Subscribe
                                </button>
                                </div>
                            ) : (
                                <>
                                    <button style={{ ...styles.btn, ...styles.btnNeutral,
                                        opacity: userSeats === stripeData.quantity ? 0.5 : 1, cursor: userSeats === stripeData.quantity ? 'not-allowed' : 'pointer'
                                     }} onClick={updateSubscription}
                                    disabled={userSeats === stripeData.quantity}>
                                        Update
                                    </button>
                                    <button style={{ ...styles.btn, ...styles.btnDanger }} onClick={unsubscribe}>
                                        Unsubscribe
                                    </button>
                                </>
                            )}
                        </div>

                        {statusMsg && <div style={styles.status}>
                            <p>{statusMsg}</p>
                            <button style={{border: "1px solid rgb(209,209,209)", borderRadius: "3px", background: "none", padding: "5px", cursor: "pointer"}}
                            onClick={()=>{
                                setStatusMsg(null);
                                getProfileData()
                            }}>Refresh</button>
                        </div>}
                    </>
                )}
            </div>
        </div>}



        <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div style={styles.cardTitle}>Connected Providers</div>
              <div style={{ fontSize: 12, color: "#64748b" }}>
                OAuth tokens linked to your account
              </div>
            </div>
            <div style={{...styles.cardBody, flex: "1", minHeight: "0", display: "flex", flexDirection: "column", gap: 10}}>
              {loading ? (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={styles.loader} />
                  <div style={{ color: "#64748b" }}>Loading tokens…</div>
                </div>
              ) : (
                <div style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px" }}>
                  <div style={{...styles.badgeRow}}>
                    {availableTokens
                    .sort((a ,b) => {
                        const aExists = usersTokens.some(t => t.Provider === a.provider) || a.provider === "DealCompass";
                        const bExists = usersTokens.some(t => t.Provider === b.provider) || b.provider === "DealCompass";
                        if (aExists && !bExists) return -1;
                        if (!aExists && bExists) return 1;
                        return a.name.localeCompare(b.name);
                    })
                    .map((t, i) => {

                    const isTokenConnected = usersTokens.some(ut => ut.Provider === t.provider);
                    // const thisToken = usersTokens.find(ut => ut.Provider === t.provider) ;

                    // if (t.provider === "google" && googleVerifyFlag === true) {
                    //     // Skip rendering Google token if not verified
                    //     return  (
                    //       <>
                    //       <span key={"abc"} 
                    //         onClick={()=>{
                    //                   handleAuthenticate(t.provider, 'drive');
                    //         }}
                    //         style={
                    //              thisToken?.Scopes?.includes('drive') ? styles.badge : styles.badgeInactive
                    //           } title={`Provider: ${t.provider}`}>
                    //           <div style={{ height: "20px", width: "40px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    //           <img src={googleDrive} alt={t.provider} style={{height: "20px", width: "auto"}}></img>
                    //           </div>
                    //           Google Drive
                    //         </span>

                    //         <span key={"def"} 
                    //         onClick={()=>{
                    //                   handleAuthenticate(t.provider, 'calendar');
                    //         }}
                    //         style={
                    //           thisToken?.Scopes?.includes('calendar') ? styles.badge : styles.badgeInactive
                    //           } title={`Provider: ${t.provider}`}>
                    //           <div style={{ height: "20px", width: "40px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    //           <img src={googleCalendar} alt={t.provider} style={{height: "20px", width: "auto"}}></img>
                    //           </div>
                    //           Google Calendar
                    //         </span>

                    //         <span key={"ghi"} 
                    //         onClick={()=>{
                    //                   handleAuthenticate(t.provider, 'gmail');
                    //         }}
                    //         style={
                    //           thisToken?.Scopes?.includes('gmail') ? styles.badge : styles.badgeInactive
                    //           } title={`Provider: ${t.provider}`}>
                    //           <div style={{ height: "20px", width: "40px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    //           <img src={gmail} alt={t.provider} style={{height: "20px", width: "auto"}}></img>
                    //           </div>
                    //         Gmail
                    //         </span>
                    //         </>
                    //     )
                    // }

                    return (
                      <span key={i} 
                      onClick={()=>{
                        if (t.provider === "DealCompass") {
                        //   navigate("/profile");
                            alert('DealCompass CRM is already connected')
                        } else {
                            if (!isTokenConnected) {
                                handleAuthenticate(t.provider);
                            } else {
                                const tokenID = usersTokens.find(ut => ut.Provider === t.provider)?.TokenID;
                                handleRevokeToken(tokenID, triggerLoadAlert, triggerFailAlert, triggerSuccessAlert, getProfileData);
                            }
                        }
                      }}
                      style={
                            usersTokens?.find(ut => ut.Provider === t.provider) || t.provider === "DealCompass" ? styles.badge : styles.badgeInactive
                        } title={`Provider: ${t.provider}`}>
                        <div style={{ height: "20px", width: "40px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img src={t.srcImage} alt={t.provider} style={{height: "20px", width: "auto"}}></img>
                        </div>
                        {t.name}
                      </span>
                    )}
                )}
                  </div>
                  <div style={{  color: "#64748b", fontSize: 12, display: "flex", gap: "5px"}}>
                    Have suggestions for new integrations? 
                    <a href="mailto:matt@dealcompass.co" style={{ color: "#0f172a", textDecoration: "underline" }}>
                       Email us
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>





        <div style={styles.card}>
            <div style={styles.cardHeader}>
              <div style={styles.cardTitle}>SMS</div>
              <div style={{ fontSize: 12, color: "#64748b" }}>
                Manage your SMS preferences
              </div>
            </div>
            <div style={{...styles.cardBody, flex: "1", minHeight: "0", display: "flex", flexDirection: "column", gap: 10}}>
              {loading ? (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={styles.loader} />
                  <div style={{ color: "#64748b" }}>Loading settings…</div>
                </div>
              ) : (
                <div style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "20px" }}>


                <div style={{width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
                   <p style={{...styles.label, fontWeight: "500"}}>Phone number</p>
                  {!isEditingPhoneNumber ? <p style={{...styles.label, display: "flex", alignItems: "center", gap: "5px", cursor: "pointer"}}
                    onClick={()=>{
                      setIsEditingPhoneNumber(true)
                    }}
                   >{phoneChatSettings?.PhoneNumber} <AiFillEdit /></p>

                    :

                   <div style={{display: "flex", alignItems: "center", gap: "0px", }}>
                    <input
                    style={{border: "1px solid #e2e8f0", borderRadius: "8px", padding: "8px", width: "150px", textAlign: "center"}}
                    type="text"
                    value={phoneChatSettings?.PhoneNumber || ""}
                    onChange={async (e) => {
                      // validate phone number format (simple)

                        const newPhoneData = {
                            ...phoneChatSettings,
                            PhoneNumber: e.target.value
                        };
                        setPhoneChatSettings(newPhoneData);
                      

                    }}
                    ></input>

                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", padding: "3px"}} onClick={()=>{
                      setIsEditingPhoneNumber(false)




                      if (phoneChatSettings?.PhoneNumber.length === 10) {
                        // Assume US number without country code
                        const updatedPhoneData = {
                            ...phoneChatSettings,
                            PhoneNumber: "1" + phoneChatSettings.PhoneNumber
                        };
                        setPhoneChatSettings(updatedPhoneData);
                        phoneChatSettings.PhoneNumber = "1" + phoneChatSettings.PhoneNumber
                      }



                      // validate phone number format (simple)
                      if (!phoneChatSettings?.PhoneNumber || phoneChatSettings?.PhoneNumber.length < 11 || !/^\+?[1-9]\d{1,14}$/.test(phoneChatSettings?.PhoneNumber)) {
                        alert("Please enter a valid phone number including area code.");
                        return;
                      }


                      // triggerLoadAlert('Updating phone number'); // --- IGNORE ---
                      updatePhoneSetting("PhoneNumber", phoneChatSettings.PhoneNumber).then(()=>{
                        // triggerSuccessAlert('Phone number updated'); // --- IGNORE ---
                        getProfileData()

                      }).catch((e)=>{
                        console.error(e)
                        triggerLoadAlert()
                        triggerFailAlert('Error updating phone number'); // --- IGNORE ---
                      })

                    }}>
                      <IoIosCheckmark size={24}/>
                    </div>

                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", padding: "3px"}} onClick={()=>{
                      setIsEditingPhoneNumber(false)
                    }}>

                      <HiXMark />
                    </div>

                  </div>}

                  </div>



                  {phoneChatSettings?.PhoneNumber && <div style={{width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
                    <p style={{...styles.label, fontWeight: "500"}}>Send text reminders</p>
                    <div style={{width: "50px", height: "25px", borderRadius: "15px", background: phoneChatSettings?.SendReminderTexts ? "#34d399" : "#d1d5db", position: "relative", cursor: "pointer"}} onClick={async ()=>{
                        // Toggle notification enabled state

                        const newState = !phoneChatSettings?.SendReminderTexts
                        const newNotificationData = {
                            ...phoneChatSettings,
                            SendReminderTexts: newState
                        };
                        setPhoneChatSettings(newNotificationData);

                        updatePhoneSetting("SendReminderTexts", newState ? 1 : 0).then(()=>{
                        }).catch((e)=>{
                          console.error(e)
                          triggerLoadAlert()
                          triggerFailAlert('Error updating setting'); 
                          setPhoneChatSettings(!newState)
                        })


                    }}>
                      <div style={{
                        width: "21px",
                        height: "21px",
                        borderRadius: "50%",
                        background: "#ffffff",
                        position: "absolute",
                        top: "2px",
                        left: phoneChatSettings?.SendReminderTexts ? "27px" : "2px",
                        transition: "left 0.2s ease-in-out",
                        zIndex: 2
                      }}></div>
                      <p
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: phoneChatSettings.SendReminderTexts ? "15px" : "",
                          right: phoneChatSettings.SendReminderTexts ? "" : "0px",
                          transform: "translate(-50%, -50%)",
                          fontSize: "10px",
                          color: phoneChatSettings?.SendReminderTexts ? "#ffffff" : "#6b7280",
                          fontWeight: "600",
                          userSelect: "none"
                        }}
                      >{phoneChatSettings.SendReminderTexts ? "On" : "Off"}</p>
                    </div>
                  </div>}


                      {phoneChatSettings.SendReminderTexts && <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", width: "100%", userSelect: "none"}}>
                        {/* ReceiveUnassignedTaskReminders toggle */}
                        <div style={{width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "10px"}}>
                          <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
                            <p style={{...styles.label, fontWeight: "500", margin: 0}}>Receive reminders for unassigned tasks</p>
                          </div>
                          <div style={{width: "50px", height: "25px", borderRadius: "15px", background: phoneChatSettings?.ReceiveUnassignedTaskReminders ? "#34d399" : "#d1d5db", position: "relative", cursor: "pointer"}}
                            onClick={async ()=>{
                              const newState = !phoneChatSettings?.ReceiveUnassignedTaskReminders;
                              const newSettings = {
                                ...phoneChatSettings,
                                ReceiveUnassignedTaskReminders: newState
                              };
                              setPhoneChatSettings(newSettings);
                              try {
                                triggerLoadAlert('Updating reminder setting');
                                await updatePhoneSetting("ReceiveUnassignedTaskReminders", newState ? 1 : 0);
                                triggerSuccessAlert('Setting updated');
                              } catch (e) {
                                triggerFailAlert('Error updating setting');
                                setPhoneChatSettings({ ...phoneChatSettings, ReceiveUnassignedTaskReminders: !newState });
                              }
                            }}>
                            <div style={{
                              width: "21px",
                              height: "21px",
                              borderRadius: "50%",
                              background: "#ffffff",
                              position: "absolute",
                              top: "2px",
                              left: phoneChatSettings?.ReceiveUnassignedTaskReminders ? "27px" : "2px",
                              transition: "left 0.2s ease-in-out",
                              zIndex: 2
                            }}></div>
                            <p
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: phoneChatSettings?.ReceiveUnassignedTaskReminders ? "15px" : "",
                                right: phoneChatSettings?.ReceiveUnassignedTaskReminders ? "" : "0px",
                                transform: "translate(-50%, -50%)",
                                fontSize: "10px",
                                color: phoneChatSettings?.ReceiveUnassignedTaskReminders ? "#ffffff" : "#6b7280",
                                fontWeight: "600",
                                userSelect: "none"
                              }}
                            >{phoneChatSettings?.ReceiveUnassignedTaskReminders ? "On" : "Off"}</p>
                          </div>
                        </div>

                        <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                          <p style={{...styles.label, fontWeight: "500"}}>Reminder times</p>
                          </div>
                          <div style={{display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px"}}>
                        {
                          phoneChatSettings?.ReminderMinutesCSV?.split(',')
                          ?.sort((a,b) => parseInt(a) - parseInt(b))
                          .map((time, index) => (
                            <div key={index} 
                            style={{...styles.btn, display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", cursor: "pointer", background: "rgb(245,245,245)",
                              border: "1px solid rgb(239,239,239)", padding: "5px", boxShadow: "none", color: "rgb(109,109,109)", fontWeight: "500"
                            }}
                                onClick={() => {
                                  if (phoneChatSettings?.ReminderMinutesCSV?.split(',').length <= 1) {
                                    alert("At least one reminder time must be set while reminders are enabled");
                                    return;
                                  }
                                  const newTimes = phoneChatSettings.ReminderMinutesCSV?.split(',').filter((_, i) => i !== index).join(',');


                                  triggerLoadAlert('Updating reminder times'); // --- IGNORE ---
                                  updatePhoneSetting("ReminderMinutesCSV", newTimes).then(()=>{
                                    setPhoneChatSettings({
                                      ...phoneChatSettings,
                                      ReminderMinutesCSV: newTimes
                                    })
                                    triggerSuccessAlert('Reminder times updated'); // --- IGNORE ---
                                  }).catch(()=>{
                                    triggerFailAlert('Error updating reminder times'); // --- IGNORE ---
                                  })

                                }}
                                >
                              <p style={{color: "rgb(79,79,79)"}}>{formatMinutes(time)}</p>
                              <HiXMark />
                            </div>
                          ))
                          
                        }
                        </div>

                        <div style={{display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "5px", marginTop: "10px"}}>

                      {phoneChatSettings?.ReminderMinutesCSV?.split(',')?.length <=2 && <div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px"}}>
                        <input
                          value={tempNewReminderTime || ""}
                          type="number"
                          onChange={(e) => setTempNewReminderTime(e.target.value)}
                          style={{
                            border: "1px solid #e2e8f0",
                            borderRadius: "8px",
                            padding: "8px",
                            width: "100px",
                            textAlign: "center",
                          }}
                        ></input>

                              <button
                                style={{...styles.btn, ...styles.btnPrimary, padding: "5px 10px", fontSize: "12px"}}
                                onClick={() => {

                                  // make sure tempNewReminderTime is a valid number and not already in the list
                                  if (isNaN(parseInt(tempNewReminderTime)) || parseInt(tempNewReminderTime) < 1 || parseInt(tempNewReminderTime) > 1440) {
                                    alert("Please enter a valid number of minutes greater than 0 and less than 1440 (one day)");
                                    return;
                                  }

                                  if (phoneChatSettings.ReminderMinutesCSV?.split(',').includes(tempNewReminderTime.toString())) {
                                    alert("This reminder time is already set");
                                    return;
                                  }

                                  const newTimes = [...phoneChatSettings.ReminderMinutesCSV?.split(','), tempNewReminderTime].sort((a,b) => parseInt(a) - parseInt(b)).join(',');
 

                                  triggerLoadAlert('Updating reminder times'); // --- IGNORE ---
                                  updatePhoneSetting("ReminderMinutesCSV", newTimes).then(()=>{
                                    setPhoneChatSettings({
                                      ...phoneChatSettings,
                                      ReminderMinutesCSV: newTimes
                                    })
                                    triggerSuccessAlert('Reminder times updated'); // --- IGNORE ---
                                  }).catch(()=>{
                                    triggerFailAlert('Error updating reminder times'); // --- IGNORE ---
                                  })



                                }}
                              >+</button>

                        </div>}
                        <p style={{color: "rgb(109,109,109)", fontSize: "12px"}}>{phoneChatSettings?.ReminderMinutesCSV?.split(',').length <= 2 ? 
                        "Minutes before (e.g. 60 = 1 hours before)" : "Max 3 reminders allowed"}</p>
                        </div>

                      </div>}

                </div>
              )}
            </div>
          </div>







        {usersTokens.find(ut => ut.Provider === "dotloop") && <div style={{...styles.card}}>
            <div style={styles.cardHeader}>
                <div style={styles.cardTitle}>Dotloop</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                    Manage your Dotloop settings
                </div>
            </div>
            <div style={styles.cardBody}>
                {loading ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={styles.loader} />
                        <div style={{ color: "#64748b" }}>Loading Dotloop data…</div>
                    </div>
                ) : (
                    <>                   
                        <DotloopMappingUI 
                          dotloopColumnMapping={dotloopColumnMapping}
                          dotloopStaticMapping={dotloopStaticMapping}
                          dealHeaderColumns={dealHeaderColumns}
                          contactHeaderColumns={contactHeaderColumns}
                        />
                    </>
                )}
            </div>
        </div>}





        </div>
      </div>
    </div>
  );
};

export default Profile;




function formatMinutes(minutes) {
    const totalMinutes = parseInt(minutes);
    
    if (totalMinutes < 60) {
        return `${totalMinutes} min`;
    }
    
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    
    if (remainingMinutes === 0) {
        return `${hours} hr`;
    }
    
    return `${hours} hr ${remainingMinutes} min`;
  }


const thStyle = { padding: "8px 10px", borderBottom: "1px solid #e2e8f0", textAlign: "left", fontWeight: 600 };
const tdStyle = { padding: "7px 10px", borderBottom: "1px solid #f1f5f9" };



const DotloopMappingUI = ({dotloopStaticMapping, dotloopColumnMapping, dealHeaderColumns, contactHeaderColumns}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempMapping, setTempMapping] = useState(() => JSON.parse(JSON.stringify(dotloopColumnMapping)));

  const { triggerLoadAlert, triggerSuccessAlert, triggerFailAlert } = useContext(FrontendDataContext);

  // Sync tempMapping if dotloopColumnMapping changes (e.g. after save/cancel)
  useEffect(() => {
    setTempMapping(JSON.parse(JSON.stringify(dotloopColumnMapping)));
  }, [dotloopColumnMapping]);

  const handleSelectChange = (dealCompassColumnID, newDotloopColumnID) => {

    console.log('Changing mapping:', dealCompassColumnID, newDotloopColumnID);
    const mappingExists = tempMapping.some(m => m.DealCompassColumnID === dealCompassColumnID);
        if (mappingExists) {
          // If no mapping exists, add a new one
        setTempMapping(prev => prev.map(m =>
          m.DealCompassColumnID === dealCompassColumnID
            ? { ...m, DotloopColumnID: newDotloopColumnID }
            : m
        ));
      } else {
        console.log('Mapping does not exist, updating');
        setTempMapping(prev => [...prev, { 
          DealCompassColumnID: dealCompassColumnID, 
          DotloopColumnID: newDotloopColumnID,
          DotloopColumnNameFromEntity: 'loop',
          DealCompassColumnIDToEntity: 'deal',
        }]);
      }
  };

  const handleSave = async () => {
    // TODO: Call backend or parent save function if needed
    // For now, just log and exit edit mode
    // You may want to lift state up and pass a save handler as prop
    setIsEditing(false);
    console.log(tempMapping)
    try {
      triggerLoadAlert('Saving Dotloop settings'); 
      await saveDotloopSettings(tempMapping);
      triggerSuccessAlert('Dotloop settings saved');
    } catch(e) {
      console.error(e)
      triggerFailAlert('Error saving Dotloop settings');
      return;
    }

    // Optionally: update dotloopColumnMapping in parent
    // e.g. onSave(tempMapping)
  };

  const handleCancel = () => {
    setTempMapping(JSON.parse(JSON.stringify(dotloopColumnMapping)));
    setIsEditing(false);
  };

  return (
    <div>
      <div style={{ fontSize: 16, color: "#64748b", marginBottom: 32, display: "flex", alignItems: "center", gap: 16 }}>
        <span>Select which DealCompass field each Dotloop column should map to.</span>
      </div>
      <div style={{ overflowX: "auto", display: "flex", flexDirection: "column", gap: "20px" }}>
        <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 480, fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={thStyle}>DealCompass Column</th>
              <th style={thStyle}>Dotloop Column</th>
            </tr>
          </thead>
          <tbody>
            {dealHeaderColumns?.map((dealCol, idx) => {
              const dotloopCol = tempMapping.find(d => d.DealCompassColumnID === dealCol.HeaderColumnID);
              return (
                <tr key={dealCol.HeaderColumnID} style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
                  <td style={tdStyle}>{dealCol.Name}</td>
                  <td style={tdStyle}>
                    <select
                      value={dotloopCol?.DotloopColumnID || ""}
                      onChange={isEditing ? e => handleSelectChange(dealCol.HeaderColumnID, e.target.value) : undefined}
                      disabled={!isEditing}
                      style={{ padding: "4px 8px", borderRadius: 4, border: "1px solid #e2e8f0", background: isEditing ? "#fff" : "#f1f5f9", color: dotloopCol?.DotloopColumnID ? "#0f172a" : "#9ca3af", cursor: isEditing ? "pointer" : "not-allowed" }}
                    >
                      <option value="">-- Select --</option>
                      {dotloopStaticMapping.filter(i => i.entity === "loop").map(dc => (
                        <option key={dc.id} value={dc.id}>
                          {dc.display_name} ({dc.entity})
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <hr style={{border: "1px solid rgb(229,229,229)"}}></hr>

        <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 480, fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={thStyle}>DealCompass Column</th>
              <th style={thStyle}>Dotloop Column</th>
            </tr>
          </thead>
          <tbody>
            {contactHeaderColumns?.map((contactCol, idx) => {
              const dotloopCol = tempMapping.find(d => d.DealCompassColumnID === contactCol.HeaderColumnID);
              return (
                <tr key={contactCol.HeaderColumnID} style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
                  <td style={tdStyle}>{contactCol.Name}</td>
                  <td style={tdStyle}>
                    <select
                      value={dotloopCol && typeof dotloopCol.DotloopColumnID !== "undefined" && dotloopCol.DotloopColumnID !== null ? String(dotloopCol.DotloopColumnID) : ""}
                      onChange={isEditing ? e => handleSelectChange(contactCol.HeaderColumnID, e.target.value) : undefined}
                      disabled={!isEditing}
                      style={{ padding: "4px 8px", borderRadius: 4, border: "1px solid #e2e8f0", background: isEditing ? "#fff" : "#f1f5f9", color: dotloopCol?.DotloopColumnID ? "#0f172a" : "#9ca3af", cursor: isEditing ? "pointer" : "not-allowed" }}
                    >
                      <option value="">-- Select --</option>
                      {dotloopStaticMapping.map(dc => (
                        <option key={dc.id} value={String(dc.id)}>
                          {dc.display_name} ({dc.entity})
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>


            <div style={{width: '100%', display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                            {!isEditing && (
                      <button style={{marginLeft: 8, padding: "4px 12px", borderRadius: 4, border: "1px solid #e2e8f0", background: "#f1f5f9", cursor: "pointer"}} onClick={()=>setIsEditing(true)}>Edit</button>
                    )}
                    {isEditing && (
                      <>
                        <button style={{marginLeft: 8, padding: "4px 12px", borderRadius: 4, border: "1px solid #1b62e7ff", background: "#1b62e7ff", color: "#fff", cursor: "pointer"}} onClick={handleSave}>Save</button>
                        <button style={{marginLeft: 8, padding: "4px 12px", borderRadius: 4, border: "1px solid #e2e8f0", background: "#f1f5f9", cursor: "pointer"}} onClick={handleCancel}>Cancel</button>
                      </>
                    )}

            </div>

      </div>
    </div>
  );
}
